
export default [
    {
        path: '/admin/dealer-withdrawals',
        name: 'dealer-withdrawal',
        meta: { requiresAuth: true },
        component: () => import('@/pages/accounting/dealer-withdrawal')
      }
]